import React, { useState } from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import DropdownMenu from '@atlaskit/dropdown-menu';
import ShowMoreHorizontalIcon from '@atlaskit/icon/core/show-more-horizontal';
import Tooltip from '@atlaskit/tooltip';

import { AudioFeatureMenuGroup, type AudioFeatureMenuItem } from './AudioFeatureMenuGroup';

const messages = defineMessages({
	moreOptionsLabel: {
		id: 'ai-audio.audio-player.overflow-menu.more-options-label',
		defaultMessage: 'More options',
		description: 'Label for the more options button in the overflow menu',
	},
});

type OverflowMenuProps = {
	items: AudioFeatureMenuItem[];
};

export const OverflowMenu = ({ items }: OverflowMenuProps): React.JSX.Element => {
	const [isOpen, setIsOpen] = useState(false);
	const { formatMessage } = useIntl();
	return (
		<Tooltip
			position="bottom"
			canAppear={() => !isOpen}
			content={formatMessage(messages.moreOptionsLabel)}
		>
			<DropdownMenu
				onOpenChange={({ isOpen: newIsOpen }) => setIsOpen(newIsOpen)}
				trigger={({ triggerRef, ...triggerProps }) => (
					<IconButton
						{...triggerProps}
						ref={triggerRef}
						appearance="subtle"
						spacing="compact"
						icon={ShowMoreHorizontalIcon}
						label={formatMessage(messages.moreOptionsLabel)}
					/>
				)}
			>
				<AudioFeatureMenuGroup items={items} />
			</DropdownMenu>
		</Tooltip>
	);
};
